import React, { useEffect, useRef } from 'react';

const WorldMap = () => {
  const mapRef = useRef();

  useEffect(() => {
    const drawVisualization = () => {
      if (!window.google || !window.google.visualization) return;
      const google = window.google;
      const data = new google.visualization.DataTable();

      // add your data and options here.
      data.addColumn('string', 'Country');
      data.addColumn('number', 'Value');
      data.addColumn({ type: 'string', role: 'tooltip' });
      data.addRows([[{ v: 'CA', f: 'Canada' }, 0, '']]);
      data.addRows([[{ v: 'US', f: 'United States' }, 1, '']]);
      data.addRows([[{ v: 'FR', f: 'France' }, 2, '']]);
      data.addRows([[{ v: 'MX', f: 'Mexico' }, 3, '']]);
      data.addRows([[{ v: 'CR', f: 'Costa Rica' }, 4, '']]);
      data.addRows([[{ v: 'BR', f: 'Brazil' }, 5, '']]);
      data.addRows([[{ v: 'PE', f: 'Peru' }, 6, '']]);
      data.addRows([[{ v: 'Gb', f: 'United Kingdom' }, 7, '']]);
      data.addRows([[{ v: 'ES', f: 'Spain' }, 8, '']]);
      data.addRows([[{ v: 'CH', f: 'Switzerland' }, 9, '']]);
      data.addRows([[{ v: 'MA', f: 'Morocco' }, 10, '']]);
      data.addRows([[{ v: 'HR', f: 'Croatia' }, 11, '']]);
      data.addRows([[{ v: 'NG', f: 'Nigeria' }, 12, '']]);
      data.addRows([[{ v: 'ZA', f: 'South Africa' }, 13, '']]);
      data.addRows([[{ v: 'SA', f: 'Saudi Arabia' }, 14, '']]);
      data.addRows([[{ v: 'AU', f: 'Australia' }, 15, '']]);
      data.addRows([[{ v: 'NZ', f: 'New Zealand' }, 16, '']]);
      data.addRows([[{ v: 'ID', f: 'Indonesia' }, 17, '']]);
      data.addRows([[{ v: 'PH', f: 'Philippines' }, 18, '']]);
      data.addRows([[{ v: 'TH', f: 'Thailand' }, 19, '']]);
      data.addRows([[{ v: 'CN', f: 'China' }, 20, '']]);
      data.addRows([[{ v: 'JP', f: 'Japan' }, 21, '']]);
      data.addRows([[{ v: 'IN', f: 'India' }, 22, '']]);
      data.addRows([[{ v: 'LK', f: 'Sri Lanka' }, 23, '']]);
      data.addRows([[{ v: 'PK', f: 'Pakistan' }, 24, '']]);
      data.addRows([[{ v: 'TJ', f: 'Tajikistan' }, 25, '']]);
      data.addRows([[{ v: 'BD', f: 'Bangladesh' }, 26, '']]);
      data.addRows([[{ v: 'PS', f: 'Palestinian Territories' }, 27, '']]);

      const options = {
        //... add your options here
        backgroundColor: { fill: '#FFFFFF', stroke: '#FFFFFF', strokeWidth: 0 },
        colorAxis: {
          minValue: 0,
          maxValue: 27,
          colors: [
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
          ],
        },
        legend: 'none',
        datalessRegionColor: '#bcbdbc',
        displayMode: 'regions',
        enableRegionInteractivity: 'true',
        resolution: 'countries',
        region: 'world',
        sizeAxis: { minValue: 1, maxValue: 1, minSize: 10, maxSize: 10 },
        keepAspectRatio: true,
        width: null,
        height: null,
        tooltip: {
          textStyle: { color: '#444444' },
          trigger: 'focus',
          isHtml: false,
        },
      };

      const chart = new google.visualization.GeoChart(mapRef.current);
      chart.draw(data, options);
    };

    const loadScript = src => {
      return new Promise(resolve => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    };

    const initialize = async () => {
      if (!window.google || !window.google.visualization) {
        await loadScript('https://www.gstatic.com/charts/loader.js');
        await loadScript('https://www.google.com/jsapi');
        window.google.charts.load('42', { packages: ['geochart'] });
        window.google.charts.setOnLoadCallback(drawVisualization);
      } else {
        drawVisualization();
      }
      window.addEventListener('resize', drawVisualization);
    };

    if (typeof window !== 'undefined') initialize();

    return () => {
      if (typeof window !== 'undefined')
        window.removeEventListener('resize', drawVisualization);
    };
  }, []);

  return <div ref={mapRef} id='map_1695834795728'></div>;
};

export default WorldMap;
